import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IRequestParametersOsd, IExceptionList } from "../models/osd";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 * @param params - Request parameters
 * @param action - API action (default: "list")
 * @param signal - AbortSignal for request cancellation
 * @returns - Array of Exception List of type IExceptionList[]
 */

export const getExceptionList = async (
  params: IRequestParametersOsd,
  action: string = "list",
  signal?: AbortSignal
): Promise<IExceptionList> => {
  try {
    const response = await axios.post(
      `${getUrl(ApiType.EXCEPTIONS_LIST)}/${action}`,
      params,
      { signal }
    );
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.getExceptionList);
  }
};
